import {Component} from '@angular/core';
import {AlertController, Platform} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {NavService} from 'shared/nav/nav.service';

import {environment} from 'environment';

import { App } from '@capacitor/app';
import { Router } from '@angular/router';
import { UserService } from 'app/profile/services/user.service';

@Component({
  selector: 'add-leader-page',
  templateUrl: 'add-leader-page.html',
  styleUrls: ['add-leader-page.scss'],
})
export class AddLeaderPage {

  public isLoading: boolean = false;
  
  public leaderId: string;
  public leaderName: string;
  public hasLeader: boolean = false;

  constructor(
    public navService: NavService,
    private userService: UserService,
    private router: Router,
  ) {
    this.isLoading = true;
    const navigation = this.router.getCurrentNavigation();
    const state = navigation.extras.state;
    if (state && state.leaderId) {
       this.leaderId = state.leaderId;
    }
    if (!this.leaderId && navigation.finalUrl && navigation.finalUrl.queryParams && navigation.finalUrl.queryParams['leaderId']) {
      this.leaderId = navigation.finalUrl.queryParams['leaderId'];
    }
    if (this.leaderId) {
      this.userService.getLeader(this.leaderId)
        .subscribe((res: string) => {
          this.leaderName = res;
          this.hasLeader = res && res.indexOf('Error: ') == -1;
          this.isLoading = false;
        });
    }
    else {
      this.leaderName = "Error: Can not retrieve leader id";
      this.isLoading = false;
    }
  }

  public onCancelClick(): void {
    this.navService.root('dashboard');
  }

  public onAcceptClick(): void {
    this.userService.setLeader(this.leaderId)
      .subscribe(() => {
        this.navService.root('dashboard').
          then(() => {
            this.navService.push('onboarding/position', {isFromMenu: true});
          });
      })

  }
}
